import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CitiShopPropsService } from '../../utility/citi-shop-props.service';

@Component({
  selector: 'app-citi-shop-header',
  templateUrl: './citi-shop-header.component.html',
  styleUrls: ['./citi-shop-header.component.scss'],
  standalone: false
})
export class CitiShopHeaderComponent implements OnChanges {
  @Input() contentHeader: any;
  @Input() userEnrolled: boolean;
  @Output() ctabuttonClicked = new EventEmitter<boolean>();
  taggingSectionName = 'Hero';
  imgSrc = '';
  isMobile = false;

  constructor(public csp: CitiShopPropsService){}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.contentHeader) {
      this.contentHeader = changes.contentHeader.currentValue;
      if(this.csp.userIsEnrolled()){
        this.contentHeader.heading = this.contentHeader?.userEnrolled?.heading;
        this.contentHeader.subHeading = this.contentHeader?.userEnrolled?.subHeading;
        this.contentHeader.postEnrollImagePath = this.contentHeader?.userEnrolled?.postEnrollImagePath;
      }
      this.contentHeader && this.onResize(null, this.contentHeader);
    }
  }

   buttonClicked(event) {
    this.ctabuttonClicked.emit(event);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event, header = null) {
    const width = window?.innerWidth || 1440;
    this.isMobile = false;
    (this.contentHeader && !header) && (header = this.contentHeader);
    const enrollmentType = (this.csp.userIsEnrolled() ?  'postEnrollImagePath' : 'preEnrollImagePath');
    if(width < 768){
      this.isMobile = true;
      this.imgSrc = this.csp.imagePrefix() + header?.[enrollmentType]?.mobile;
    }
    else if(768 <= width && 1024 >= width){
      this.imgSrc = this.csp.imagePrefix() + header?.[enrollmentType]?.tablet;
    }
    else {
      this.imgSrc = this.csp.imagePrefix() + header?.[enrollmentType]?.desktop;
    }
    
  }
}
